module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.203d753a.ttf";